import { render, staticRenderFns } from "./DealSheet.vue?vue&type=template&id=31b6b52f&scoped=true&"
import script from "./DealSheet.vue?vue&type=script&lang=js&"
export * from "./DealSheet.vue?vue&type=script&lang=js&"
import style0 from "./DealSheet.vue?vue&type=style&index=0&id=31b6b52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6b52f",
  null
  
)

export default component.exports